import PublisherBanners from '../../../../actions/PublisherBanners';
import query from '../../../../helpers/query';
import { removeParams } from '../helpers';
import CustomNotify from "../../../Notify";

export const actions = {
    getBanners(state, actionType) {
        const params = {
            ...query.parseToSend(state),
            ...removeParams(),
            q: state.nameLink,
            offer_ids: Number(state.offerId) || state.offer_ids
        };

        PublisherBanners.getBanners(params);
    },

    getLocales(state) {
        PublisherBanners.getLocales({
            offer_ids: state.offerId
        });
    },

    getDimensions(state) {
        PublisherBanners.getDimensions({
            offer_ids: state.offerId
        });
    },

    getMimeTypes(state) {
        PublisherBanners.getMimeTypes({
            offer_ids: state.offerId
        });
    },

    saveBannerPresets(state, t, onSuccess, onError) {
        const notyNames = t.notyMessages;

        let params = {
            publisher_id: state.publisherId,
            offer_id: state.offer.id,
            link_id: state.currentLink.id,
            params: JSON.stringify(state.banner.params)
        };

        PublisherBanners.saveBannerPresets(params).then(data => {
            CustomNotify(notyNames.update);
            onSuccess && onSuccess();
        }).catch(err => {
            onError && onError(err.error.invalid_parameters);
        });
    }
};
